export enum LoginOrigin {
    BOOKING_UI = "bookingUI",
    CUSTOMER_UI = "customerUI"
}